export const serializeQuery = (query: Record<string, unknown> = {}): string => {
  const params = new URLSearchParams();

  Object.keys(query).sort().forEach((key) => {
    const value = query[key];
    if (value === undefined || value === null || value === '') {
      return;
    }

    if (Array.isArray(value)) {
      if (value.length === 0) {
        return;
      }
      params.set(key, value.join(','));
      return;
    }

    params.set(key, String(value));
  });

  return params.toString();
};
